// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { OnAfterCodeLoad } from "@lg/shared";
import { BoInfoSymbol, HasChangedInternallySymbol } from "@lg/shared/for-apps";
// Auto-generated by Lowgile
import { jsonClass, jsonProperty } from "@sumbricht/json-class-serializer";
import { proxySignal, ProxySignal, signal, computed, Signal } from "../../signals.js";
import { HasSignalProperties } from "@lg/shared/for-apps";
import { immerable } from "immer";
import { DataLoader } from "@lg/shared/for-apps";
import { Subject } from "rxjs";
import { z } from "zod";
import { AppContext } from "@lg/ng-shared";
import { ChangeDetectorRef } from "@angular/core";

const θdataLoader =
    new DataLoader(() => ProcessingMethod.loadInternal(), entryList => {
        ProcessingMethod.θentryList.set(entryList)
        ProcessingMethod.θonEntryListUpdated()
    }, { doCache: true, expireAfterMs: 0 })
    ;

// Auto-generated by Lowgile
export class ProcessingMethod {
    readonly [BoInfoSymbol] = Object.freeze({
        boType: "StaticEntity" as const,
        editablePropertyNames: ["id"] as const,
        computedPropertyNames: ["label"] as const,
        allPropertyNames: ["id", "label"] as const,
        propertyNamesOfInterest: [] as const,
    });
    readonly [HasSignalProperties] = true;
    readonly [HasChangedInternallySymbol] = new Subject<void>();
    readonly θid: ProxySignal<ProcessingMethod.Id | null>;
    static readonly Id = String;
    static ids: ProcessingMethod.Id[] = [] as any;
    static idsAndDisplayValues: Record<ProcessingMethod.Id, string> = {} as any;
    static θentryList = signal<ProcessingMethod.Entry[] | undefined>(this.θgetStaticEntryList());
    static θentryMap = computed(() => {
        const objEntries = this.θentryList()?.map(e => [e.id, e]) ?? []
        return Object.freeze(Object.fromEntries(objEntries))
    });
    static θchoicesCache = new Map<string, Sys.Types.Choice[]>();
    static θfilteredCache = new Map<string, Signal<ProcessingMethod.Entry[]>>();
    readonly θhasOthers = false;
    static readonly $displayProperty = 'label';
    [immerable] = true;
    readonly θlabel = computed(() => {
        const id = this.θid()
        return id !== null ? ProcessingMethod.getEntryMap()[id]?.label : undefined
    });
    readonly $isOther = false;

    static get [BoInfoSymbol]() {
        return ProcessingMethod[BoInfoSymbol]
    }

    get __type(): 'Orders.ProcessingMethod' {
        return 'Orders.ProcessingMethod'
    }

    set __type(_) {
    }

    static get __type(): 'Orders.ProcessingMethod' {
        return 'Orders.ProcessingMethod'
    }

    static set __type(_) {
    }

    @jsonProperty()
    get id(): ProcessingMethod.Id | null {
        return this.θid()
    }

    set id(id: ProcessingMethod.Id | ProcessingMethod | null) {
        if (id !== null && typeof id == 'object') { id = id.id }

        if (id != null && !ProcessingMethod.getEntry(id as ProcessingMethod.Id)) throw new Error('Invalid id for type Orders.ProcessingMethod: ' + id)
        this.θid.set(id as ProcessingMethod.Id | null)
        this[HasChangedInternallySymbol].next()
    }

    get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    static get __boType(): 'StaticEntity' {
        return 'StaticEntity'
    }

    get ids(): ProcessingMethod.Id[] {
        return ProcessingMethod.ids
    }

    get idsAndDisplayValues(): Record<ProcessingMethod.Id, string> {
        return ProcessingMethod.idsAndDisplayValues
    }

    get $displayValue(): string {
        return this.$isOther ? (this as any).$other : String((this as any)[ProcessingMethod.$displayProperty])
    }

    get label() {
        return this.θlabel()
    }

    get isTurningOnLathe() {
        return this.id == 'turningOnLathe'
    }

    static get TurningOnLathe() {
        return new this('turningOnLathe')
    }

    get isFlatMachining() {
        return this.id == 'flatMachining'
    }

    static get FlatMachining() {
        return new this('flatMachining')
    }

    get isBending() {
        return this.id == 'bending'
    }

    static get Bending() {
        return new this('bending')
    }

    get isUnknown() {
        return this.id == 'unknown'
    }

    static get Unknown() {
        return new this('unknown')
    }

    constructor(idOrObject: ProcessingMethod.Id | ProcessingMethod | null = null) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid = proxySignal(id)

    }

    getEntryList(filters?: { entryProperty: string, values: any[] }[]): ProcessingMethod.Entry[] {
        return This.ProcessingMethod.getEntryList(filters)
    }

    static getEntryList(filters?: { entryProperty: string, values: any[] }[]): ProcessingMethod.Entry[] {
        if (filters) {
            const key = JSON.stringify(filters)
            let filteredList = this.θfilteredCache.get(key)
            if (!filteredList) {
                filteredList = computed(() => this.θentryList()?.filter(entry => filters.every(filter => filter.values.includes(entry[filter.entryProperty]))) ?? [])
                this.θfilteredCache.set(key, filteredList)
            }

            return filteredList()
        }

        return this.θentryList()
    }

    static getEntryMap() {
        return this.θentryMap()
    }

    static getEntry(id: ProcessingMethod.Id) {
        const entryMap = this.getEntryMap()
        return entryMap[id]
    }

    static getChoices(labelColumn: keyof ProcessingMethod.Entry = '$displayValue'): Sys.Types.Choice[] {
        if (labelColumn == "$displayValue") labelColumn = ProcessingMethod.$displayProperty
        let options = this.θchoicesCache.get(labelColumn)
        if (!options) {
            const entryList = this.getEntryList() ?? []
            options = entryList.map(entry => ({ id: entry.id, label: String(entry[labelColumn]), $isOther: false }))
            this.θchoicesCache.set(labelColumn, options)
        }

        return options
    }

    static async load(forceReload = false) {
        if (forceReload) {
            this.θentryList.set(await θdataLoader.forceReloadAndGetData())
        } else {
            this.θentryList.set(await θdataLoader.waitAndGetValidData())
        }

        this.θonEntryListUpdated()
        return this.θentryList()
    }

    static async loadInternal(): Promise<ProcessingMethod.Entry[]> {
        const dynamicEntryList = []
        this.θchoicesCache.clear()
        return createReadonlyProxy(true, [...this.θgetStaticEntryList(), ...dynamicEntryList])
    }

    toJSON() {
        return this.id
    }

    $clone() {
        return new ProcessingMethod(this.id)
    }

    $equals(other: any) {
        if (this.id !== other?.id) return false

        return true
    }

    θtoPlainObject() {
        return this.id
    }

    θtoIdAndOther(idOrObject: ProcessingMethod.Id | ProcessingMethod | null) {
        if (idOrObject && typeof idOrObject == 'object') {
            return { id: idOrObject.id }

        } else {
            return { id: idOrObject as ProcessingMethod.Id | null, otherValue: '' }

        }
    }

    θupdate(idOrObject: ProcessingMethod.Id | ProcessingMethod) {
        const { id } = this.θtoIdAndOther(idOrObject)
        this.θid.set(id)

    }

    static θonEntryListUpdated() {
        this.ids = this.getEntryList().map(e => e.id)
        this.idsAndDisplayValues = Object.fromEntries(this.getEntryList().map(e => [e.id, e.$displayValue] as const)) as Record<ProcessingMethod.Id, string>
        AppContext.resolve(ChangeDetectorRef).detectChanges()
    }

    static async θafterCodeLoad() {
        return this.load().catch(err => {
            console.log('Could not load entries of StaticEntity Orders.ProcessingMethod yet:', err.message)
            //throw err
        })
    }

    setTurningOnLathe() {
        this.id = 'turningOnLathe'

    }

    setFlatMachining() {
        this.id = 'flatMachining'

    }

    setBending() {
        this.id = 'bending'

    }

    setUnknown() {
        this.id = 'unknown'

    }

    static θgetStaticEntryList() {
        return Object.freeze([
            Object.freeze({ id: "turningOnLathe", label: "Turning" }),
            Object.freeze({ id: "flatMachining", label: "Flat machining" }),
            Object.freeze({ id: "bending", label: "Bending" }),
            Object.freeze({ id: "unknown", label: "Unknown" })
        ] as ProcessingMethod.Entry[]) as ProcessingMethod.Entry[]
    }
}
jsonClass('Orders.ProcessingMethod')(ProcessingMethod)

export const ProcessingMethodθId = String;

export type ProcessingMethodθId = string;

export namespace ProcessingMethod {
    export type Id = 'turningOnLathe' | 'flatMachining' | 'bending' | 'unknown'

    export interface Entry {
        id: ProcessingMethod.Id;
        label: string;
        $displayValue?: string;
    }
}
Sys.Language.languageChanged$.subscribe(() => ProcessingMethod.load(true))
